export default __webpack_public_path__ + "static/media/opportunitiesFilled.f091442b.svg";